module.exports = __webpack_public_path__ + "img/cointo-board.228ea01e.png";